import {Svg, Path} from 'react-native-svg';

// Jotary brand marks, inlined as react-native-svg so they render identically
// on web and native. Paths taken from the prototype's jotary_logomark.svg
// (icon) and logo_light.svg (wordmark).

interface LogoProps {
  size?: number;
}

// Square "j" logomark (orange). viewBox 0 0 52 52.
export function JotaryLogomark({size = 20}: LogoProps) {
  return (
    <Svg viewBox="0 0 52 52" width={size} height={size}>
      <Path d="M33 48L33 40H34.6452C37.5 40 40 39 40 35.2337L40 15H48L48 36.1107C48 44.2481 44.3226 48 35.129 48H33Z" fill="#EC6A37"/>
      <Path d="M40 4H48V12H40V4Z" fill="#EC6A37"/>
      <Path d="M37 8H8V44L30 44" stroke="#FFA481" strokeWidth={8}/>
    </Svg>
  );
}

interface WordmarkProps {
  height?: number;
}

// Full "jotary" wordmark (dark ink, for use on light backgrounds).
// viewBox 0 0 215 52 — width is derived from height to preserve aspect.
export function JotaryWordmark({height = 22}: WordmarkProps) {
  const width = (215 / 52) * height;
  return (
    <Svg viewBox="0 0 215 52" width={width} height={height}>
      <Path d="M33 48L33 40H34.6452C37.5 40 40 39 40 35.2337L40 15H48L48 36.1107C48 44.2481 44.3226 48 35.129 48H33Z" fill="#EC6A37"/>
      <Path d="M40 4H48V12H40V4Z" fill="#EC6A37"/>
      <Path d="M37 8H8V44L30 44" stroke="#FFA481" strokeWidth={8}/>
      <Path d="M191.458 48.8538L195.599 39.3522L185.123 14.258H193.699L199.644 29.753L205.54 14.258H214.116L199.693 48.8538H191.458Z" fill="#190A2F"/>
      <Path d="M165.701 39.5958V14.258H174.131V21.1772C174.959 16.9867 177.396 13.7708 181.878 13.7708C182.463 13.7708 183.097 13.8195 183.779 14.0144V22.0543C183.145 21.9081 182.609 21.8593 181.927 21.8593C176.86 21.8593 174.131 25.1727 174.131 29.753V39.5958H165.701Z" fill="#190A2F"/>
      <Path d="M145.825 40.083C140.173 40.083 133.839 35.7951 133.839 26.9269C133.839 18.0587 140.173 13.7708 145.825 13.7708C150.259 13.7708 152.647 16.2071 152.842 16.6456H152.988V14.258H161.418V39.5958H152.988V37.2082H152.842C152.647 37.6467 150.259 40.083 145.825 40.083ZM142.122 26.9269C142.122 30.4839 144.705 32.6279 147.628 32.6279C150.649 32.6279 153.183 30.5327 153.183 26.9269C153.183 23.3211 150.649 21.2259 147.628 21.2259C144.705 21.2259 142.122 23.3699 142.122 26.9269Z" fill="#190A2F"/>
      <Path d="M126.9 39.8881C121.833 39.8881 118.178 37.4518 118.178 31.1174V20.8848H114.329V14.258H118.178V7.7774H126.608V14.258H131.968V20.8848H126.608V29.8505C126.608 31.0199 127.29 32.4817 129.678 32.4817C130.263 32.4817 131.188 32.3843 132.065 32.0919V38.4751C131.091 39.5471 128.801 39.8881 126.9 39.8881Z" fill="#190A2F"/>
      <Path d="M99.7049 40.083C93.0294 40.083 86.1589 35.5515 86.1589 26.9269C86.1589 18.3023 93.0294 13.7708 99.7049 13.7708C106.332 13.7708 113.202 18.3023 113.202 26.9269C113.202 35.5515 106.332 40.083 99.7049 40.083ZM94.4424 26.9269C94.4424 30.289 96.7813 32.5304 99.7049 32.5304C102.58 32.5304 104.919 30.289 104.919 26.9269C104.919 23.5648 102.58 21.3234 99.7049 21.3234C96.7813 21.3234 94.4424 23.5648 94.4424 26.9269Z" fill="#190A2F"/>
      <Path d="M68 49V41.2525H69.6567C73.0188 41.2525 74.6755 40.4241 74.6755 36.2337V14.258H83.1052V37.1107C83.1052 45.2481 79.402 49 70.144 49H68Z" fill="#190A2F"/>
      <Path d="M74.6801 4V12H83.1089V4H74.6801Z" fill="#190A2F"/>
    </Svg>
  );
}
